'use strict';

var React = require('react');

var SvgImagesMajor = function SvgImagesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 10.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.01 6.01a2.75 2.75 0 0 1 2.74-2.51h5a2.75 2.75 0 0 1 2.75 2.75v5a2.75 2.75 0 0 1-2.51 2.74 2.75 2.75 0 0 1-2.74 2.51h-5a2.75 2.75 0 0 1-2.75-2.75v-5a2.75 2.75 0 0 1 2.51-2.74Zm-1.01 7.74v-.978l1.625-1.95a.25.25 0 0 1 .369-.017l3.226 3.225a.75.75 0 0 0 1.06 0l1.22-1.22v.94c0 .69-.56 1.25-1.25 1.25h-5c-.69 0-1.25-.56-1.25-1.25Zm7.5-5v1.94l-1.75 1.75-2.695-2.696a1.75 1.75 0 0 0-2.582.117l-.473.567v-1.678c0-.69.56-1.25 1.25-1.25h5c.69 0 1.25.56 1.25 1.25Zm-4.975-2.75h3.725a2.75 2.75 0 0 1 2.75 2.75v3.725c.57-.116 1-.62 1-1.225v-5c0-.69-.56-1.25-1.25-1.25h-5c-.605 0-1.11.43-1.225 1Z"
  }));
};
SvgImagesMajor.displayName = "ImagesMajor";

exports.SvgImagesMajor = SvgImagesMajor;
